import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const CTASection = () => {
  return (
    <section className="py-20 bg-primary">
      <div className="container mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4">
            Ready for Your Caribbean Adventure?
          </h2>
          <p className="text-primary-foreground/70 text-lg max-w-xl mx-auto mb-8">
            Book your transfer or tour today and experience the Dominican Republic like never before
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/#booking">
              <Button size="lg" className="gap-2 rounded-none bg-secondary text-secondary-foreground hover:bg-secondary/90 font-bold px-8">
                Book a Transfer <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
            <Link to="/tours">
              <Button size="lg" variant="outline" className="gap-2 rounded-none border-white/30 text-white hover:bg-white/10 font-bold px-8">
                Explore Tours <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
